import { type MailboxInfo, getIndexerValueForMailboxInfo } from "owa-client-types";
import { createStore } from "owa-satcheljs";
import { mutatorAction } from "satcheljs";

const getStore = createStore("premiumEncryptionStore", {
    isPremiumEncryptionMap: new Map<string, boolean>(),
});

export const setHavePremiumEncryptionMutator: (mailboxInfo: MailboxInfo, value: boolean) => void = mutatorAction("setHavePremiumEncryption", (mailboxInfo: MailboxInfo, value: boolean): void => {
    const indexer = getIndexerValueForMailboxInfo(mailboxInfo);
    getStore().isPremiumEncryptionMap.set(indexer, value);
});

export function getHavePremiumEncryption(mailboxInfo: MailboxInfo): boolean {
    const indexer = getIndexerValueForMailboxInfo(mailboxInfo);
    return !!getStore().isPremiumEncryptionMap.get(indexer);
}
export function hasPremiumEncryptionSet(mailboxInfo: MailboxInfo): boolean {
    const indexer = getIndexerValueForMailboxInfo(mailboxInfo);
    return getStore().isPremiumEncryptionMap.has(indexer);
}
